import { SecurityRoles, SecurityGroups, SecurityAuthenticate } from '../services/auth-guard.service';

export const RequireAuthentication = 'security-authentication';

/**
 * Requires that the user is authenticated and is a member one of the specified roles in order to authorize access to the component
 * @param roles The list of roles that are authorized to access this component
 * @param authenticate Whether or not to redirect the user to the login screen if the user is not authenticated; The default is true
 */
export function RolesAllowed(roles: Array<string>, authenticate?: boolean) {
  return function decorator(target: any) {
      target[SecurityRoles] = roles;
      target[RequireAuthentication] = true;
      target[SecurityAuthenticate] = (authenticate === undefined || authenticate === true) ? true : false;
  };
}

/**
 * Requires that the user is authenticated and is a member one of the specified groups in order to authorize access to the component
 * @param groups The list of groups that are authorized to access this component
 * @param authenticate Whether or not to redirect the user to the login screen if the user is not authenticated; The default is true
 */
export function GroupsAllowed(groups: Array<string>, authenticate?: boolean) {
  return function decorator(target: any) {
    target[SecurityGroups] = groups;
    target[RequireAuthentication] = true;
    target[SecurityAuthenticate] = (authenticate === undefined || authenticate === true) ? true : false;
  };
}

/**
 * Requires that the user is authenticated in order to authorize access to the component
 * @param authenticate Whether or not to redirect the user to the login screen if the user is not authenticated; The default is true
 */
export function PermitAll(authenticate?: boolean) {
  return function decorator(target: any) {
    target[RequireAuthentication] = true;
    target[SecurityAuthenticate] = (authenticate === undefined || authenticate === true) ? true : false;
  };
}